export default __webpack_public_path__ + "static/media/alert.92ae044d.mp3";